import Model from '../model';

/**
 * RegistrationToken Model
 * @property registration_token
 * @property __className
 */
export default class RegistrationTokenModel extends Model {
  /**
   * RegistrationToken Model Constructor
   * add a 'fields' property which holds form-field types and validation information
   * @param registration
   * @param formType
   * @param token
   */
  constructor(registration/* , formType, token */) {
    super(registration);
    this.__className = 'RegistrationTokenModel';
    this.group_slug = null;

    this.rows = [
      {
        registration_token: {
          type: 'text',
          validation: 'required|alpha_num|max:8',
          class: 'col-md-6',
        },
      },
    ];
  }

  check() {
    try {
      return Model.getApi().checkRegistrationToken(this);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
      return undefined;
    }
  }

  /**
   * Set the dealer slug on the model.
   * TODO CSR-50 set Group slug
   *
   * @param {string} groupSlug
   */
  setDealerSlug(groupSlug) {
    this.group_slug = groupSlug;
  }

  setRecaptchaToken(token) {
    this.recaptcha_token = token;
  }
}
